import React from 'react';
import '../styles-v2/Mi-contacto.css';

const miContacto = () => {

    return (


            <div className="contact-bottom">
                Copyright © 2025 -
                <a
                    href="https://www.linkedin.com/in/matias-pozzi/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-link"

                >
                    <span>Matias Pozzi</span>
                </a>
            </div>


    );
};

export default miContacto;